export const createSamplingPointCountKey = (code: string, description?: string) =>
  `${code}::${description ?? ''}`
